import React, { Suspense, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import { GlobalStyles } from './components/GlobalStyles';

import Router from './components/Router';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';

export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <BrowserRouter>
      <GlobalStyles />
      <ScrollToTop />
      <CookieConsent />
      <Header loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
      <Suspense fallback={'Loading...'}>
        <Router loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}
